import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import PartnerWorkplaceSelect from './PartnerWorkplaceSelect';
import { SelectValue } from '../../../Select/Select';

interface Props extends BaseFieldProps {
	partnerId: number;
	onChange?: (value: SelectValue) => void;
}

const PartnerWorkplaceSelectField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<PartnerWorkplaceSelect partnerId={props.partnerId} />
		</BaseField>
	);
};

export default PartnerWorkplaceSelectField;
